module.exports = __webpack_public_path__ + "img/foto 12.10eeea0b.jpg";